export enum ConfirmationResult {
  ACCEPT,
  CANCEL,
}
